import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { SelectField } from "../../../../../../features/forms/fields/select-field/select-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

import { MarketingSupportLevelOptions } from "../../types/marketing-support-level-options.constant";

export const CbTemplateControlMarketingSupportLevel = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <SelectField
      form={props.form}
      label="Level of marketing support required"
      name="marketingSupportLevel"
      options={MarketingSupportLevelOptions}
      required
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
